<div class="container">
  <div class="row mb-4">
    <div class="col">
      <h1>Administration</h1>
      <p class="lead">Welcome to the TermWebPublish administration dashboard.</p>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-card-title>System Status</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <pub-termweb-status-text></pub-termweb-status-text>
          @if (!isConfigurationOk) {
            <div class="mt-2">
              <a mat-flat-button color="primary" [routerLink]="['/admin/settings']">Configure TermWeb Connection</a>
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-md-4 mb-3">
      <mat-card appearance="outlined" class="h-100">
        <mat-card-header>
          <mat-icon mat-card-avatar>view_quilt</mat-icon>
          <mat-card-title>Page Layouts</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Configure the appearance and components of the search page.</p>
        </mat-card-content>
        <mat-card-actions>
          <a mat-button color="primary" [routerLink]="['/admin/layouts']">MANAGE LAYOUTS</a>
        </mat-card-actions>
      </mat-card>
    </div>

    <div class="col-md-4 mb-3">
      <mat-card appearance="outlined" class="h-100">
        <mat-card-header>
          <mat-icon mat-card-avatar>settings</mat-icon>
          <mat-card-title>Settings</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Manage TermWeb connection and synchronization settings.</p>
        </mat-card-content>
        <mat-card-actions>
          <a mat-button color="primary" [routerLink]="['/admin/settings']">MANAGE SETTINGS</a>
        </mat-card-actions>
      </mat-card>
    </div>

    <div class="col-md-4 mb-3">
      <mat-card appearance="outlined" class="h-100" [class.disabled-card]="!isConfigurationOk">
        <mat-card-header>
          <mat-icon mat-card-avatar>translate</mat-icon>
          <mat-card-title>Dictionaries</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>Manage synchronized dictionaries and visible content.</p>
        </mat-card-content>
        <mat-card-actions>
          <a mat-button color="primary" [routerLink]="['/admin/dictionaries']" [disabled]="!isConfigurationOk">MANAGE
          DICTIONARIES</a>
          <a mat-button color="primary" [routerLink]="['/admin/fields']" [disabled]="!isConfigurationOk">MANAGE
          SEARCHABLE FIELDS</a>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
</div>
